import React from 'react'
import PropTypes from 'prop-types'

const SwishError = ({ errorType, errorMsg }) => {
  if (errorType === 'MISSSING_CELL_PHONE') {
    return (
      <span className="paragraph-regular-14">
        Det är ej möjligt att genomföra betalningen eftersom giltigt mobiltelefonnummer saknas, vänligen kontakta kundservice.
      </span>
    )
  } else if (errorType === 'INVALID_CELL_PHONE') {
    return (<span className="paragraph-regular-14">{errorMsg}</span>)
  } else {
    return (
      <span className="paragraph-regular-14">
        Det gick inte att genomföra betalningen, vänligen kontakta kundservice.
      </span>
    )
  }
}

SwishError.propTypes = {
  errorType: PropTypes.string,
  errorMsg: PropTypes.string
}

export default SwishError
